import React from 'react';
import './ReadabilitySection.css';
import { getScoreColorClass } from 'utils/scoreColors';
import { useTranslation } from 'react-i18next';

const ReadabilitySection = ({ data }) => {
  console.log(data);
  const { t } = useTranslation();
  
  const longPhrases = data?.longPhrases || { score: 0, count: 0, total: 0 };
  const paragraphLength = data?.paragraphLength || { score: 0, count: 0, total: 0 };
  const adaptedWording = data?.adaptedWording || { ageRange: 0 };
  
  return (
    <div className="readability-section">
      {/* Long Phrases Section */}
      <div className="metric-subsection">
        <div className="subsection-header">
          <div className="subsection-title">{t('Phrases de +20 mots')} :</div>
          <div
            className={`subsection-score  ${getScoreColorClass(
              longPhrases.score
            )}`}
          >
            {longPhrases.score}%
          </div>
        </div>

        <div className="subsection-content">
          <p className="metric-text">
            {t('Vous avez')} {longPhrases.count} {t('phrase')}
            {longPhrases.count > 1 ? 's' : ''} {t('de +20 mots sur')}{' '}
            {longPhrases.total} {t('phrase')}
            {longPhrases.total > 1 ? 's' : ''}.
          </p>

          {longPhrases['recommendation '] && (
            <div className="ux-recommendation">
              <span className="recommendation-icon"></span>
              <div className="recommendation-content">
                <span className="recommendation-label">
                  {t('Notre recommandation')} :{' '}
                </span>
                <span className="recommendation-text">
                  {t(longPhrases['recommendation '])}
                </span>
              </div>
            </div>
          )}
          {longPhrases.gratification && (
            <div className="success-message">
              <span className="emoji">🎉</span>{' '}
              {t(longPhrases.gratification)}
            </div>
          )}
        </div>
      </div>

      <hr className="keyword-position-divider" />

      {/* Paragraph Length Section */}
      <div className="metric-subsection">
        <div className="subsection-header">
          <div className="subsection-title">
            {t('Longueur des paragraphes')} :
          </div>
          <div
            className={`subsection-score  ${getScoreColorClass(
              paragraphLength.score
            )}`}
          >
            {paragraphLength.score}%
          </div>
        </div>

        <div className="subsection-content">
          <p className="metric-text">
            {t('Vous avez')} {paragraphLength.count} {t('paragraphe')}
            {paragraphLength.count > 1 ? 's' : ''} {t('de +100 mots sur')}{' '}
            {paragraphLength.total} {t('paragraphe')}
            {paragraphLength.total > 1 ? 's' : ''}.
          </p>
          {paragraphLength.recommendation && (
            <div className="ux-recommendation">
              <span className="recommendation-icon"></span>
              <div className="recommendation-content">
                <span className="recommendation-label">
                  {t('Notre recommandation')} :{' '}
                </span>
                <span className="recommendation-text">
                  {t(paragraphLength.recommendation)}
                </span>
              </div>
            </div>
          )}

          {paragraphLength.gratification && (
            <div className="success-message">
              <span className="emoji">🎉</span>{' '}
              {t(paragraphLength.gratification)}
            </div>
          )}
        </div>
      </div>
      <hr className="keyword-position-divider" />

      {/* Adapted Wording Section */}
      <div className="metric-subsection">
        <div className="subsection-header">
          <div className="subsection-title">{t('Wording adapté')} :</div>
        </div>

        <div className="subsection-content">
          {adaptedWording?.ageRange != 0 && (
            <p className="metric-text">
              {t(adaptedWording.ageRange + '.')}
            </p>
          )}
          {adaptedWording.recommendation && (
            <div className="ux-recommendation">
              <span className="recommendation-icon"></span>
              <div className="recommendation-content">
                <span className="recommendation-label">
                  {t('Notre recommandation')} :{' '}
                </span>
                <span className="recommendation-text">
                  {t(adaptedWording.recommendation)}
                </span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ReadabilitySection;
